module.exports = __webpack_public_path__ + "static/media/en_add_to_google_wallet.d6395ad1.svg";